import { render, staticRenderFns } from "./FieldHelpContent.vue?vue&type=template&id=38f1a176&scoped=true"
import script from "./FieldHelpContent.vue?vue&type=script&lang=js"
export * from "./FieldHelpContent.vue?vue&type=script&lang=js"
import style0 from "./FieldHelpContent.vue?vue&type=style&index=0&id=38f1a176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f1a176",
  null
  
)

export default component.exports